// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_47a102', '__Lato_Fallback_47a102'","fontStyle":"normal"},"className":"__className_47a102"};